import axios from 'axios';
import actions from './actions';
import { appOperations } from '../../../../../App/store';
import ColoredSnackbarConstants from '../../../../misc/ColoredSnackbar/ColoredSnackbarConstants';

const { setPresets, setTotalCount, setLoading } = actions;
const { openSnack } = appOperations;

const fetchPresets = (page, rowsPerPage, searchTerm) => async (dispatch) => {
    dispatch(setLoading(true));
    try {
        const response = await axios.get('/api/admin/VideoPresets/GetVideoPresetsList', {
            params: {
                pageNumber: page,
                pageSize: rowsPerPage,
                searchPhrase: searchTerm || null
            }
        });
        
        const { items, total } = response.data;
        
        dispatch(setPresets(items || []));
        dispatch(setTotalCount(total !== undefined ? total : (items?.length || 0)));
        
    } catch (error) {
        console.error("Error fetching presets:", error);
        dispatch(openSnack('Failed to fetch presets', ColoredSnackbarConstants.SNACKBAR_ERROR));
    } finally {
        dispatch(setLoading(false));
    }
};

const updatePresets = (presetUpdates) => async (dispatch, getState) => {
    dispatch(setLoading(true));
    
    try {
        const updatePromises = presetUpdates.map(preset => 
            axios.post('/api/admin/VideoPresets/UpdateVideoPreset', preset, {
                headers: { 'Content-Type': 'application/json' }
            })
        );
        
        await Promise.all(updatePromises);

        dispatch(openSnack('Presets updated successfully!', ColoredSnackbarConstants.SNACKBAR_SUCCESS));
        
        const { page, rowsPerPage, searchTerm } = getState().presetsPage;
        dispatch(fetchPresets(page, rowsPerPage, searchTerm));
        
    } catch (error) {
        console.error("Error updating presets:", error);
        dispatch(openSnack('Failed to update presets.', ColoredSnackbarConstants.SNACKBAR_ERROR));
    } finally {
        dispatch(setLoading(false));
    }
};

export default { fetchPresets, updatePresets };